import React, {useEffect, useState} from 'react';

import OnMapInfoPanel from "./OnMapInfoPanel";
import Shape from "../../shapes/Shape";
import Locations from "../../locations/Locations";
import ShapeStyling from "../../shapes/ShapeStyling";
import ShapeToolbar from "../../shapes/ShapeToolbar";
import ShapePopup from "../../shapes/ShapePopup";
import ShapeNotesDisplay from "../../shapes/ShapeNotesDisplay";


export default function MarksInfoPanelBufferRadius({properties, onChange, canEdit = false}) {
    const [radius, setRadius] = useState(properties.bufferRadius ? properties.bufferRadius : 0.1);
    const [measurementUnits, setMeasurementUnits] = useState(properties.bufferRadiusMeasurementUnits ? properties.bufferRadiusMeasurementUnits : 'm');

    useEffect(() => {
        if (properties.bufferRadius) {
            setRadius(parseFloat(properties.bufferRadius));
        } else {
            setRadius(1);
        }

        if (properties.bufferRadiusMeasurementUnits) {
            setMeasurementUnits(properties.bufferRadiusMeasurementUnits);
        } else {
            setMeasurementUnits('m');
        }
    }, [properties]);


    const save = () => {
        let cleanRadius = parseFloat(radius),
            cleanMeasurementUnits = measurementUnits ? measurementUnits : 'm';

        if (isNaN(cleanRadius) || cleanRadius < 0.1) {
            cleanRadius = 0.1;
            setRadius(cleanRadius);
        }

        onChange({
            radius: cleanRadius,
            measurementUnits: cleanMeasurementUnits
        });
    }


    return canEdit ? (<>
        <div className="my-2">
            <div className="shape-info-panel-label fs-2">Buffer Radius:</div>
            <div className="d-flex align-items-center gap-2">
                <input type="text" className="shape-info-panel-input w-100" value={radius} onChange={(e) => {
                    setRadius(e.target.value);
                }} />

                <select className="shape-info-panel-select" value={measurementUnits ? measurementUnits : 'm'} onChange={(e) => {
                    setMeasurementUnits(e.target.value);
                }}>
                    <option value="m">m</option>
                    <option value="km">km</option>
                    <option value="mi">mi</option>
                </select>

                <button className="icon-button d-flex position-relative" style={{transform: 'none'}} onClick={save}><i className={'ti ti-device-floppy fs-4'}></i></button>
            </div>
        </div>
    </>) : (<>
        Buffer Radius: {radius ? radius : 0} {measurementUnits ? measurementUnits : 'm'}
    </>);
}